module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/main-visual-text-3a4a1faabc5605f60e3e1c5ff486e8c9.svg";